// extracted by mini-css-extract-plugin
export var hero = "hero-module--hero--DgBe6";
export var heroContent = "hero-module--heroContent--1qPYV";
export var heroContentLeft = "hero-module--heroContentLeft--1khkg";
export var heroContentLeftBox = "hero-module--heroContentLeftBox--3LiNz";
export var heroButton = "hero-module--heroButton--z5vcX";
export var heroContentRight = "hero-module--heroContentRight--_8uZ3";
export var heroContentL = "hero-module--heroContentL--q9EmR";
export var heroContentRightL = "hero-module--heroContentRightL--3QH85";
export var heroContentM = "hero-module--heroContentM--2dYlJ";
export var heroContentRightM = "hero-module--heroContentRightM--3abgo";
export var heroContentM1 = "hero-module--heroContentM1--34cfw";
export var heroContentLeftM1 = "hero-module--heroContentLeftM1--2g_Hv";
export var heroContentRightM1 = "hero-module--heroContentRightM1--1qbtZ";
export var heroSM = "hero-module--heroSM---bfGN";
export var heroContentSM = "hero-module--heroContentSM--3Nk3k";
export var heroContentLeftSM = "hero-module--heroContentLeftSM--3ysPr";
export var heroContentLeftTablet = "hero-module--heroContentLeftTablet--Xqufr";
export var heroContentMobile = "hero-module--heroContentMobile--3x4eb";
export var heroContentLeftMobile = "hero-module--heroContentLeftMobile--3NBF-";